export default "__VITE_ASSET__DClCGfS2__"